import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import {
  isPartnershipTeam,
  isPlatformAdmin,
  isRegularInternalUser,
} from "utils/roles";

type CalibrateAdminRouteProps = {
  children: ReactNode;
  allowRegularInternalUsers?: boolean;
  allowPartnershipTeam?: boolean;
};

const CalibrateAdminRoute = ({
  children,
  allowRegularInternalUsers = false,
  allowPartnershipTeam = false,
}: CalibrateAdminRouteProps): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const pp = user?.platform_profile;

  if (user && !user.is_pass_reset) {
    return <Navigate to="/reset-password" replace />;
  }

  const hasAccess =
    isPlatformAdmin(pp) ||
    (allowRegularInternalUsers && isRegularInternalUser(pp)) ||
    (allowPartnershipTeam && isPartnershipTeam(pp));

  if (!user || !hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default CalibrateAdminRoute;
